import { getImprovementColor, getImprovementLabel } from "@Helpers/feedback";
import useI18n from "@i18n";
import { Stack, SxProps, Typography, useTheme } from "@mui/material";

interface IBybTrendChip {
  improvementPercentage: number;
  sx?: SxProps;
}

const BybTrendChip = ({ improvementPercentage, sx = {} }: IBybTrendChip) => {
  const { i18n } = useI18n();
  const theme = useTheme();

  const trendColor = getImprovementColor(improvementPercentage, theme);
  const trendLabel = getImprovementLabel(improvementPercentage);

  return (
    <Stack spacing={0.5} bgcolor={`${trendColor}20`} paddingY={0.6} paddingX={1.75} borderRadius={2} sx={sx}>
      <Typography variant="textBase500" color={trendColor}>
        {i18n(trendLabel)}
      </Typography>
    </Stack>
  );
};

export default BybTrendChip;
